import { useState } from "react";
import { Trash2 } from "lucide-react";
import BatchActionBar from "../../components/BatchActionBar";

const demoUploads = [
    {
        id: 1,
        image: "https://i.pravatar.cc/100?img=1",
        fullName: "Onur Can",
        type: "Profile Photo",
        createdOn: "Tuesday 3rd February 2026 6:50 AM"
    },
    {
        id: 2,
        image: "https://i.pravatar.cc/100?img=2",
        fullName: "Onur Can",
        type: "Cover Photo",
        createdOn: "Tuesday 3rd February 2026 6:50 AM"
    },
    {
        id: 3,
        image: "https://i.pravatar.cc/100?img=3",
        fullName: "Raheel Shehzadiiiiiii",
        type: "Uploaded Photo",
        createdOn: "Monday 2nd February 2026 8:15 AM"
    },
    {
        id: 4,
        image: "https://i.pravatar.cc/100?img=4",
        fullName: "seeq lee",
        type: "Profile Photo",
        createdOn: "Monday 2nd February 2026 12:42 AM"
    },
    {
        id: 5,
        image: "https://i.pravatar.cc/100?img=5",
        fullName: "seeq lee",
        type: "Cover Photo",
        createdOn: "Monday 2nd February 2026 12:42 AM"
    },
    {
        id: 6,
        image: "https://i.pravatar.cc/100?img=6",
        fullName: "TABBU SINGH",
        type: "Profile Photo",
        createdOn: "Saturday 31st January 2026 9:45 AM"
    }
];

export default function UserUploads() {
    const [searchTerm, setSearchTerm] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [uploads, setUploads] = useState(demoUploads);

    // Multi-delete state
    const [selectedIds, setSelectedIds] = useState([]);

    const filteredUploads = uploads.filter(upload =>
        upload.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        upload.type.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleToggleSelectAll = () => {
        if (selectedIds.length === filteredUploads.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(filteredUploads.map((u) => u.id));
        }
    };

    const handleToggleSelectRow = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const handleBatchDelete = () => {
        setUploads((prev) => prev.filter((u) => !selectedIds.includes(u.id)));
        setSelectedIds([]);
    };

    const handleDelete = (id) => {
        setUploads(uploads.filter(upload => upload.id !== id));
        setSelectedIds((prev) => prev.filter((i) => i !== id));
    };

    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-800 dark:text-white">User Uploads</h1>

            <div className="bg-white dark:bg-slate-800 rounded-xl shadow-lg overflow-hidden border border-gray-200 dark:border-slate-700">
                {/* Header Controls */}
                <div className="p-4 border-b border-gray-200 dark:border-slate-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div className="flex items-center gap-2">
                        <span className="text-sm text-gray-600 dark:text-gray-400">Show</span>
                        <select
                            value={entriesPerPage}
                            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                            className="px-3 py-1.5 bg-gray-100 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500"
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </select>
                        <span className="text-sm text-gray-600 dark:text-gray-400">entries</span>
                    </div>

                    <div className="flex items-center">
                        <span className="text-sm text-gray-600 dark:text-gray-400 mr-2">Search:</span>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="px-4 py-1.5 bg-gray-100 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500 w-48"
                        />
                    </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-gray-50 dark:bg-slate-700/50">
                                <th className="px-4 py-4 w-12 text-center">
                                    <input
                                        type="checkbox"
                                        checked={filteredUploads.length > 0 && selectedIds.length === filteredUploads.length}
                                        onChange={handleToggleSelectAll}
                                        className="w-4 h-4 rounded border-gray-300 dark:border-slate-600 text-pink-600 focus:ring-pink-500 cursor-pointer"
                                    />
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                                    Image
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                                    Full Name
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                                    Type
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                                    Created On
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-slate-700">
                            {filteredUploads.map((upload) => {
                                const isSelected = selectedIds.includes(upload.id);
                                return (
                                <tr key={upload.id} className={`transition-colors ${isSelected ? "bg-pink-50/70 dark:bg-pink-500/10" : "hover:bg-gray-50 dark:hover:bg-slate-700/30"}`}>
                                    <td className="px-4 py-4 text-center">
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => handleToggleSelectRow(upload.id)}
                                            className="w-4 h-4 rounded border-gray-300 dark:border-slate-600 text-pink-600 focus:ring-pink-500 cursor-pointer"
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <img
                                            src={upload.image}
                                            alt={upload.fullName}
                                            className="w-10 h-10 rounded-full object-cover ring-2 ring-gray-200 dark:ring-slate-600"
                                        />
                                    </td>
                                    <td className="px-6 py-4 text-sm text-pink-500 font-medium hover:underline cursor-pointer">
                                        {upload.fullName}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                                        {upload.type}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                                        {upload.createdOn}
                                    </td>
                                    <td className="px-6 py-4">
                                        <button
                                            onClick={() => handleDelete(upload.id)}
                                            className="flex items-center gap-1.5 px-4 py-1.5 bg-gradient-to-r from-red-500 to-red-600 text-white text-xs font-medium rounded-md hover:opacity-90 transition-opacity shadow-sm"
                                        >
                                            <Trash2 className="w-3.5 h-3.5" />
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                {filteredUploads.length === 0 && (
                    <div className="p-8 text-center text-gray-500 dark:text-gray-400">
                        No uploads found.
                    </div>
                )}

                {/* Pagination */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-4 border-t border-gray-200 dark:border-slate-700">
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                        Showing 1 to {filteredUploads.length} of {uploads.length} entries
                    </p>
                    <div className="flex items-center gap-2">
                        <button className="px-4 py-2 text-sm text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-slate-700 rounded-lg hover:bg-gray-200 dark:hover:bg-slate-600 transition-colors">
                            Previous
                        </button>
                        <button className="px-4 py-2 text-sm text-white bg-pink-500 rounded-lg">
                            1
                        </button>
                        <button className="px-4 py-2 text-sm text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-slate-700 rounded-lg hover:bg-gray-200 dark:hover:bg-slate-600 transition-colors">
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {/* Floating Multi-Delete Bar */}
            <BatchActionBar
                selectedCount={selectedIds.length}
                totalCount={filteredUploads.length}
                onClearSelection={() => setSelectedIds([])}
                onSelectAll={handleToggleSelectAll}
                onDeleteSelected={handleBatchDelete}
                entityName="uploads"
            />
        </div>
    );
}
